import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardPreviewOrgRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { OrgDashboardOrgSubLayoutHandleProps } from '#/modules/orgDashboard/sub-layouts/Org/OrgDashboardOrgSubLayoutHandleProps';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardPreviewOrgPageContainerLoadable } from './OrgDashboardPreviewOrgPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
  orgDashboardSubLayoutVariant: 'base',
} satisfies LayoutHandleProps & OrgDashboardOrgSubLayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardPreviewOrgRoute>,
) {
  await OrgDashboardPreviewOrgPageContainerLoadable.load();
}

export default function OrgDashboardPreviewOrgHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardPreviewOrgPageContainerLoadable />;
}
